import AuthService from './auth'
import { createAxiosClient } from './core'

const client = createAxiosClient('/api/listados')

export default AuthService.register(client)
